@if (label) {
  <label class="select-label">{{ label | translateTA }}</label>
}
<nz-select
    [formControl]="selectFormControl"
    [nzPlaceHolder]="(placeholder || label) | translateTA"
    nzShowSearch
    [nzFilterOption]="filterOption"
    [compareWith]="compareWith"
    [nzNotFoundContent]="'notfound' | translateTA"
    (ngModelChange)="onChange($event)">
  @for (item of options; track item) {
    <nz-option [nzValue]="item" [nzLabel]="getDisplay(item)"></nz-option>
  }
</nz-select>
